const initialState = {
  score: '',
};

const getters = {};

const actions = {
  set({ commit }, score) {
    commit('SET', score);
  },

  add({ commit, state }, score) {
    const newScore = (state.score || 0) + score;
    commit('SET', newScore);
  },
};

const mutations = {
  SET(state, score) {
    state.score = score;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
